import { useRef, useEffect } from "react";
import { createChart, AreaSeries, ColorType } from "lightweight-charts";

export default function CpiChart({ data, color = "#3b82f6", height = 140 }) {
  const containerRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current || !data || data.length === 0) return;

    if (chartRef.current) {
      chartRef.current.remove();
      chartRef.current = null;
    }

    const chart = createChart(containerRef.current, {
      autoSize: true,
      layout: {
        background: { type: ColorType.Solid, color: "transparent" },
        textColor: "#71717a",
        fontFamily: "'JetBrains Mono', monospace",
        fontSize: 9,
      },
      grid: {
        vertLines: { visible: false },
        horzLines: { color: "rgba(63,63,70,0.12)" },
      },
      rightPriceScale: {
        borderVisible: false,
        scaleMargins: { top: 0.1, bottom: 0.05 },
      },
      timeScale: {
        borderVisible: false,
        fixLeftEdge: true,
        fixRightEdge: true,
      },
      crosshair: {
        vertLine: { color: "rgba(59,130,246,0.3)", width: 1, style: 2, labelBackgroundColor: "#1e40af" },
        horzLine: { color: "rgba(59,130,246,0.3)", width: 1, style: 2, labelBackgroundColor: "#1e40af" },
      },
      handleScroll: false,
      handleScale: false,
    });

    chartRef.current = chart;

    const series = chart.addSeries(AreaSeries, {
      lineColor: color,
      topColor: `${color}22`,
      bottomColor: "transparent",
      lineWidth: 2,
    });

    const chartData = data.map(d => ({
      time: d.date.length === 7 ? `${d.date}-01` : d.date,
      value: d.value,
    }));

    series.setData(chartData);
    chart.timeScale().fitContent();

    return () => {
      if (chartRef.current) {
        chartRef.current.remove();
        chartRef.current = null;
      }
    };
  }, [data, color]);

  if (!data || data.length === 0) {
    return (
      <div style={{ height }} className="flex items-center justify-center text-zinc-600 text-[10px]">
        No data available
      </div>
    );
  }

  return <div ref={containerRef} style={{ height }} data-testid="cpi-chart" />;
}
